export type Bbox = [[number, number], [number, number]];

export function isInstanceOfEmailResult(object: any): boolean {
    return object?.__typename == 'Email';
}

export function isInstanceOfFile(object: any): boolean {
    return object?.__typename === 'File';
}
